var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-content',{attrs:{"title":_vm.title}},[_c('template',{slot:"header"},[_vm._v(" "+_vm._s(_vm.$t(("" + (_vm.$route.meta.title['code'])), { name: _vm.title }))+" ")]),_c('table-component',{attrs:{"campaign":_vm.campaign}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }